export function getScriptAbsUrlFromImportFunction(fn) {
    const fnString = fn.toString();
    const match = fnString.match(/import\([\s\S]*?["'](.+?)["'][\s\S]*?\)/);
    if (match && match[1]) {
        const extractedUrl = match[1];
        if (extractedUrl.startsWith('http://') || extractedUrl.startsWith('https://')) {
            return extractedUrl;
        }
        return new URL(extractedUrl, import.meta.url).href;
    }
    throw new Error('Could not extract import URL from function');
}
//# sourceMappingURL=helpers.js.map